import { z } from 'zod';

export const TransformRunningDetails = z.object({
  status: z.literal('Running'),
});

export type TransformRunningDetails = z.infer<typeof TransformRunningDetails>;
